import storageService from '@/services/storage.service'
import cryptojsService from '@/services/cryptojs.service'
import environment from '@/environment'
import api from '@/servicesTS/higia-api-provider.service'

const _PRIVILEGIOS_KEY = 'grantedAuthorities'

const temPrivilegioFn = (to) => {
    if (to.meta.requiresAuth == false) {
        return true
    } else {
        const privilegios = getPrivilegios()
        const privilegiosRota = _getPrivilegiosRota(to)
        if (privilegios == null) {
            return false
        } else if (privilegiosRota != null) {
            for (let i = 0; i < privilegiosRota.length; i++) {
                if (privilegios.indexOf(privilegiosRota[i]) > -1) {
                    return true
                }
            }
        } else {
            return true
        }
        return false
    }
}

const setPrivilegios = (privilegios) => {
    storageService.set(_PRIVILEGIOS_KEY, cryptojsService.encrypted(privilegios, true))
}

const updatePrivilegios = () => {
    storageService.remove(_PRIVILEGIOS_KEY)
    api.apiProvider
        .get(environment.authApi + '/usuario/authorities/nocache')
        .then((res) => {
            setPrivilegios(res.data.authorities)
            aplicarPrivilegiosTemplate()
        })
        .catch((err) => {})
}

const getPrivilegios = () => {
    try {
        const privilegios = JSON.parse(cryptojsService.decrypt(storageService.get(_PRIVILEGIOS_KEY)))
        return privilegios.map((item) => {
            return item.replace('ROLE_', '')
        })
    } catch (error) {
        return null
    }
}

const _getPrivilegiosRota = (to) => {
    if (to.meta.roles) {
        return to.meta.roles
    } else {
        for (let i = to.matched.length - 2; i >= 0; i--) {
            if (to.matched[i].meta.roles) {
                return to.matched[i].meta.roles
            }
        }
        return null
    }
}

const aplicarPrivilegiosTemplate = () => {
    const privilegios = getPrivilegios()
    if (privilegios) {
        $('[data-permissao]').each(function (i, elemento) {
            let dataPermissoes, permissoes, permissao, privilegio, contador
            dataPermissoes = $(this).data('permissao')
            if (dataPermissoes.indexOf(',') > -1) {
                permissoes = dataPermissoes.split(',')
                privilegio = false
                contador = 0
                permissoes.forEach((_permissao) => {
                    contador++
                    permissao = _permissao.trim()
                    privilegio = privilegio ? true : _privilegioAcao(_permissao, false, this, privilegios)
                    if (contador == permissoes.length) {
                        _aplicarPrivilegio(privilegio, elemento)
                    }
                })
            } else {
                permissao = dataPermissoes
                _privilegioAcao(permissao, true, this, privilegios)
            }
        })
    }
}

const _aplicarPrivilegio = (temPrivilegio, elemento) => {
    if (temPrivilegio) {
        $(elemento).removeClass('hidden').removeAttr('data-permissao')
    } else {
        $(elemento).addClass('hidden')
    }
}

const _privilegioAcao = (permissaoValor, origemTemplate, elemento, privilegios) => {
    if (privilegios && privilegios.length) {
        let permissao = privilegios.filter((item) => item == permissaoValor).length
        if (permissao) {
            if (origemTemplate) {
                _aplicarPrivilegio(true, elemento)
            } else {
                return true
            }
        } else {
            if (origemTemplate) {
                _aplicarPrivilegio(false, elemento)
            } else {
                return false
            }
        }
    }
    return false
}

const compararPrivilegios = (permissao) => {
    const privilegios = getPrivilegios()
    if (privilegios && privilegios.length) {
        return _privilegioAcao(permissao, null, null, privilegios)
    }
    return null
}

const getPermissoes = () => {
    return {
        MEDICO: compararPrivilegios('MEDICO'),
        MEDICO_RESPONSAVEL: compararPrivilegios('MEDICO_RESPONSAVEL'),
        CREDENCIAMENTO: compararPrivilegios('CREDENCIAMENTO'),
        CAM: compararPrivilegios('CAM'),
        JURIDICO: compararPrivilegios('JURIDICO'),
        CADASTRO: compararPrivilegios('CADASTRO'),
    }
}

export default {
    temPrivilegioFn,
    setPrivilegios,
    updatePrivilegios,
    getPrivilegios,
    compararPrivilegios,
    aplicarPrivilegiosTemplate,
    getPermissoes,
}
